import React from 'react';
import PropTypes from 'prop-types';

const SelectInput = props => {
  const {className, id, value, onChange, name, label, selectOptions,disabled, wrapperClass} = props;
  return (
    <div
      className={wrapperClass}
    >
      <label
        htmlFor={id}
      >
        {label}
      </label>
      <div
        className={className}
      >
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option value=''>Select from list</option>
          {
            selectOptions.map((selectOption, key) => {
              return (
                <option value={selectOption.value} key={key}>
                  {selectOption.name}
                </option>
              )
            })

          }
        </select>
      </div>
    </div>
  )
};

SelectInput.propTypes = {
  className: PropTypes.string,
  wrapperClass:PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.node,
  disabled: PropTypes.bool
};

export default SelectInput;
